import styled from 'styled-components';
import ModalBase from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
export const Container = styled.div``;

export const Modal = styled(ModalBase)`
  border-radius: 20px;
  div {
    position: absolute !important;
    top: 0 !important;
    z-index: 1000 !important;
  }
`;
